import React, { Component } from 'react';
import {Link} from "react-router";
import AuthService from "../../service/AuthService"
import {currentSiteName} from "../../service/SiteService";
import SiteService from "../../service/SiteService";

class AuthenticatedNav extends Component {
  render() {
      const configLinkActive = ['builds', 'actions', 'connections', 'logs'].includes(this.props.tab);

      return (
        <nav className="navbar navbar-inverse navbar-fixed-top top-nav">
            <div className="container-fluid">
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                            data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                    </button>
                    <div className="visible-xs navbar-brand">{this.props.title}</div>
                    <Link className="hidden-xs navbar-brand" to="/dashboard">{currentSiteName}</Link>
                </div>

                <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul className="nav navbar-nav">
                        <li className={ `hidden-sm ${this.props.tab === 'dashboard' && "active"}` }><Link to="/dashboard"><i className="icon icon-gauge"/> Dashboard <span className="sr-only">(current)</span></Link></li>

                        {/* Always visible */}
                        <li className={ this.props.tab === 'account' && "active" }><Link to="/account"><i className="icon icon-user"/> Account</Link></li>

                        {/* Always visible */}
                        {SiteService.isMocksSite() &&
                        <li className={ this.props.tab === 'mocks' && "active" }><Link to="/mocks"><i className="icon icon-thunder-cloud"/> API Mocks</Link></li>}

                        {/* Visible above xs */}
                        {SiteService.isBotSite() &&
                        <li className={ `dropdown hidden-xs ${configLinkActive && "active"}` }>
                            <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="icon icon-rocket"/> Slack Bot <span className="caret" /></a>
                            <ul className="dropdown-menu">
                                <li className={ this.props.tab === 'builds' && "active" }><Link to="/bot/builds"><i className="icon icon-archive"/> Build history</Link></li>
                                <li role="separator" className="divider" />
                                <li className="dropdown-header">Configure</li>
                                <li className={ this.props.tab === 'actions' && "active" }><Link to="/bot/actions"><i className="icon icon-cog"/> Actions</Link></li>
                                <li className={ this.props.tab === 'connections' && "active" }><Link to="/bot/connections"><i className="icon icon-power-plug"/> Connections</Link></li>
                                <li role="separator" className="divider" />
                                <li className="dropdown-header">Advanced</li>
                                <li className={ this.props.tab === 'logs' && "active" }><Link to="/logs"><i className="icon icon-text-document"/> Logs</Link></li>
                            </ul>
                        </li>}

                        {/* Expand build and deploy at xs */}
                        {SiteService.isBotSite() && <li className={ `visible-xs ${this.props.tab === 'builds' && "active"}` }><Link to="/bot/builds"><i className="icon icon-archive"/> Build history</Link></li>}
                        {SiteService.isBotSite() && <li className={ `visible-xs ${this.props.tab === 'actions' && "active"}` }><Link to="/bot/actions"><i className="icon icon-rocket"/> Bot Actions</Link></li>}
                        {SiteService.isBotSite() && <li className={ `visible-xs ${this.props.tab === 'connections' && "active"}` }><Link to="/bot/connections"><i className="icon icon-power-plug"/> Bot Connections</Link></li>}
                        <li className={ this.props.tab === 'logs' && "active" }><Link to="/logs"><i className="icon icon-text-document"/> View Logs</Link></li>

                        {/* Always visible */}
                        <li className={ this.props.tab === 'docs' && "active" }><Link to="/docs"><i className="icon icon-help-with-circle"/> Documentation</Link></li>
                    </ul>
                    <ul className="nav navbar-nav navbar-right">
                        <li><Link to="/" onClick={(e) => { e.preventDefault(); AuthService.logout(); }}><i className="icon icon-log-out"/> Log out</Link></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
  }
}

AuthenticatedNav.propTypes = {
    tab: React.PropTypes.string,
    title: React.PropTypes.string
};

AuthenticatedNav.defaultProps = {
    title: currentSiteName
};

export default AuthenticatedNav;



// WEBPACK FOOTER //
// ./src/modules/common/nav/AuthenticatedNav.js